import { render, staticRenderFns } from "./AdditionalResourceView.vue?vue&type=template&id=e18f97ca"
import script from "./AdditionalResourceView.vue?vue&type=script&lang=ts"
export * from "./AdditionalResourceView.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalResourceView.vue?vue&type=style&index=0&id=e18f97ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports